module.exports = __webpack_public_path__ + "static/media/YM23_1.2de50593.jpg";